import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'tag.remove-option-label': {
    id: 'tag.remove-option-label',
    defaultMessage: 'Remove {label}',
    description: 'Accessible label for removing a selected tag option.'
  }
});
